import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import WorkIcon from '@mui/icons-material/Work';
import SearchIcon from '@mui/icons-material/Search';
import { Box, CircularProgress, Collapse, Divider, Grid, IconButton, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Email, Group, MailOutline } from '@mui/icons-material';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { REQUIRED_RED } from '../../App';
import { preventPhoneInputKeys } from '../../components/FormatNumber/FormatNumber';
import { MuiDisabledTextField, MuiDisablesTextFieldWithFocus40, MuiSelectWithFocus, MuiTextFieldWithFocus } from '../../config/MaterialUIConstants';
import { formatPhoneNumber, inputFormatPhoneNumber, removeDashFromPhoneNumber } from '../../container/Common/FormatPhoneNumber';
import { SmallPhoneTypeIcon } from '../../container/Customers/Profile/CustomerProfileLeftDataSection';
import { CustomersListBasedOnType } from '../../redux/Invoice/action';
import { useCheckPhoneNumber } from '../../services/business/customer/customer.hooks.js';
import { useQuickReviewUsers } from '../../services/business/reviewRequest/reviewRequest.hooks.js';
import { useGetCountryMasterList } from '../../services/core/master/master.hooks';
import { CHIP_COLOR, masterQueryOptions } from '../../utility/Constant';
import FleetIconSvg from '../../utility/Svg/FleetIconSvg';
import { MultiSelectAutocomplete } from './MultiSelectAutocomplete.jsx';

const styles = {
    label: {
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '24px',
        color: '#212121',
    },
    phoneTypeSelect: {
        ...MuiSelectWithFocus,
        '& .MuiSelect-icon': { right: '8px !important' },
        '& .MuiSelect-select': {
            width: '70px',
            paddingLeft: '12px!important',
            paddingRight: '12px!important',
        },
    },
    phoneTypeMenuProps: {
        PaperProps: {
            style: {
                width: '140px',
                marginTop: '2px',
                marginLeft: '34px',
                boxShadow: '0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 5px 5px -3px rgba(0, 0, 0, 0.20)',
                borderRadius: '4px',
            },
        },
    },
    countrySelect: {
        width: 'auto',
        minWidth: 'auto',
        height: '50px',
        border: 'none',
        marginRight: '8px',
        boxShadow: 'none',
    },
    countrySelectMenuProps: {
        PaperProps: {
            style: {
                width: '264px',
                marginLeft: '86px',
                boxShadow: '0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
            },
        },
    },
    countrySelectSx: {
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
        '& .MuiSelect-select': {
            paddingLeft: '0px',
            paddingRight: '32px !important',
            marginRight: '0!important',
            display: 'flex',
            alignItems: 'center',
            gap: '0',
        },
        background: 'transparent',
    },
    flagContainer: {
        width: '22px',
        height: '16px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        fontSize: '20px',
    },
    arrowButtonStyles: {
        position: 'absolute',
        top: '29px',
        zIndex: 2,

        width: '24px',
        height: '24px',
        padding: '0 6px',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        borderRadius: '50%',
        background: '#006CDD',
        boxShadow: '0 3px 10.5px rgba(0,0,0,0.25)',

        color: '#fff',
        minWidth: 'unset',

        '&:hover': {
            background: '#006CDD',
        },
    },
};

const labelStyle = {
    fontSize: '16px',
    fontWeight: 500,
    color: '#111827',
    mb: 1,
};

const fieldStyle = {
    '& .MuiOutlinedInput-root': {
        height: 44,
        borderRadius: '6px',
        backgroundColor: '#fff',
        '& input': { fontSize: '15px' },
    },
};

const PhoneField = ({
    label,
    isRequired = true,
    phoneNumberFieldName,
    control,
    errors,
    setValue,
    setError,
    clearErrors,
    selectedCountry,
    handleCountryChange,
    countryList,
    phoneInputRef,
    setNewCustomer,
    isCheckingPhone = false,
    phoneTypes,
}) => {
    return (
        <Stack spacing={1}>
            <Typography variant="body1" style={styles.label}>
                {label} {isRequired && <span style={{ color: REQUIRED_RED }}>*</span>}
            </Typography>

            <Stack direction="row" spacing={1}>
                <Controller
                    name={phoneNumberFieldName}
                    control={control}
                    rules={
                        isRequired
                            ? {
                                  required: 'Phone Number is required',
                                  pattern: {
                                      value: /^\d{3}-\d{3}-\d{4}$/,
                                      message: 'Phone number should be 10 digits long',
                                  },
                              }
                            : {
                                  pattern: {
                                      value: /^\d{3}-\d{3}-\d{4}$/,
                                      message: 'Phone number should be 10 digits long',
                                  },
                              }
                    }
                    render={({ field }) => (
                        <TextField
                            InputProps={{
                                startAdornment: (
                                    <Select
                                        style={styles.countrySelect}
                                        MenuProps={styles.countrySelectMenuProps}
                                        sx={styles.countrySelectSx}
                                        value={selectedCountry?._id ?? ''}
                                        onChange={handleCountryChange}
                                        renderValue={(selected) => {
                                            const country = countryList?.find((item) => item._id === selected) || selectedCountry;
                                            if (!country) return 'Search';
                                            return (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                    }}
                                                >
                                                    <div style={styles.flagContainer}>{country.flag}</div>
                                                    <span style={{ fontSize: '16px', fontWeight: 400, lineHeight: ' 150%' }}>{country.dial_code}</span>
                                                </div>
                                            );
                                        }}
                                        IconComponent={UnfoldMoreIcon}
                                    >
                                        {countryList?.length > 0 &&
                                            countryList.map((country) => (
                                                <MenuItem key={country._id} value={country._id} style={{ height: '44px' }}>
                                                    <span style={{ marginRight: '8px' }}>
                                                        <img src={country?.flag_svg} alt="flag" style={{ width: '24px', height: '12px' }} />
                                                    </span>
                                                    {country.country} ({country.dial_code})
                                                </MenuItem>
                                            ))}
                                    </Select>
                                ),

                                endAdornment: isCheckingPhone && (
                                    <div
                                        style={{
                                            width: '24px',
                                            height: '24px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <CircularProgress size={20} />
                                    </div>
                                ),
                            }}
                            inputRef={phoneInputRef ? (el) => (phoneInputRef.current = el) : null}
                            sx={{
                                ...MuiTextFieldWithFocus,
                                '& .MuiInputBase-root': {
                                    marginRight: '0!important',
                                    borderRadius: '8px',
                                    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                    height: '50px',
                                },
                            }}
                            variant="outlined"
                            fullWidth
                            error={!!errors[phoneNumberFieldName]}
                            helperText={errors[phoneNumberFieldName] ? errors[phoneNumberFieldName].message : ''}
                            {...field}
                            onChange={(e) => {
                                if (removeDashFromPhoneNumber(e.target.value).length <= 10) {
                                    const input = e.target;
                                    const rawValue = e.target.value;
                                    const prevCursorPosition = input.selectionStart;
                                    const isDeleting = e.nativeEvent.inputType === 'deleteContentBackward';
                                    const hyphenCountBefore = (rawValue.match(/-/g) || []).length;
                                    const formattedValue = inputFormatPhoneNumber(rawValue);
                                    const hyphenCountAfter = (formattedValue.match(/-/g) || []).length;

                                    let newCursorPosition = prevCursorPosition;
                                    if (isDeleting) {
                                        if (hyphenCountAfter < hyphenCountBefore) newCursorPosition--;
                                    } else {
                                        if (hyphenCountAfter > hyphenCountBefore) newCursorPosition++;
                                    }
                                    newCursorPosition = Math.max(0, Math.min(newCursorPosition, formattedValue.length));

                                    setValue(phoneNumberFieldName, formattedValue);

                                    setNewCustomer((prev) => ({
                                        ...prev,
                                        phoneNumber: formattedValue,
                                    }));

                                    setTimeout(() => {
                                        input.setSelectionRange(newCursorPosition, newCursorPosition);
                                    }, 0);

                                    const cleanLength = removeDashFromPhoneNumber(e.target.value).length;
                                    if (cleanLength < 10 && (isRequired || cleanLength > 0)) {
                                        setError(phoneNumberFieldName, {
                                            message: 'Phone Number should be 10 digits',
                                        });
                                    } else {
                                        clearErrors(phoneNumberFieldName);
                                    }
                                }
                            }}
                            onKeyDown={(e) => preventPhoneInputKeys(e)}
                        />
                    )}
                />
            </Stack>
        </Stack>
    );
};

const CHIP_STYLES = {
    shop_created: {
        bg: CHIP_COLOR.SHOP_CREATED_BG,
        color: CHIP_COLOR.SHOP_CREATED_COLOR,
        label: 'Shop Created',
    },
    shop_imported: {
        bg: CHIP_COLOR.SHOP_IMPORTED_BG,
        color: CHIP_COLOR.SHOP_IMPORTED_COLOR,
        label: 'Shop Imported',
    },
    apex_auto_app: {
        bg: CHIP_COLOR.APEX_AUTO_APP_BG,
        color: CHIP_COLOR.APEX_AUTO_APP_COLOR,
        label: 'Apex Auto',
    },
};

const CustomerSelector = ({
    selectedCustomer,
    setSelectedCustomer,
    newCustomer,
    setNewCustomer,
    selectedCountry,
    setSelectedCountry,
    phoneTypes,
    selectedPhoneTypes,
    setSelectedPhoneTypes,
    addCustomerOpen,
    setAddCustomerOpen,
    prefetchedQuickReviewUsers,
    prefetchedCustomersPage1,
    prefetchedCustomersPage1Meta,
    onFoundCustomerChange,
}) => {
    const {
        control,
        setValue,
        reset,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm();

    const [showArrows, setShowArrows] = useState(false);
    const scrollContainerRef = useRef(null);
    const [customers, setCustomers] = useState([]);
    const [search, setSearch] = useState('');

    const [loading, setLoading] = useState(false);
    const [isFetchingNextPage, setIsFetchingNextPage] = useState(false);

    const [foundCustomerOption, setFoundCustomerOption] = useState(null);
    const [selectedViaLookup, setSelectedViaLookup] = useState(null);
    const [cachedNewCustomerForUndo, setCachedNewCustomerForUndo] = useState(null);

    const customerLimit = 50;
    const [page, setPage] = useState(1);
    const [pageMeta, setPageMeta] = useState({
        totalpages: prefetchedCustomersPage1Meta?.totalPages ?? prefetchedCustomersPage1Meta?.totalpages ?? 0,
        currentPage: prefetchedCustomersPage1Meta?.currentPage ?? prefetchedCustomersPage1Meta?.page ?? 1,
    });

    const dispatch = useDispatch();
    const cancelTokenSourceRef = useRef(null);

    const phoneInputRef = useRef(null);
    const debounceRef = useRef(null);
    const lastPhoneCheckKeyRef = useRef('');

    const params = { limit: 5 };
    const { data } = useQuickReviewUsers(params, { enabled: !prefetchedQuickReviewUsers });
    const customersList = prefetchedQuickReviewUsers?.list || prefetchedQuickReviewUsers || data?.list || [];

    const shopCountryId = localStorage.getItem('shopCountryId') || '64e738882fec8f2c9b79c139';

    // Normalize to array
    const selectedArray = Array.isArray(selectedCustomer) ? selectedCustomer : [];

    const { data: countryList, isLoading: countryListLoader } = useGetCountryMasterList(
        { countryId: shopCountryId },
        { enabled: !!shopCountryId, ...masterQueryOptions }
    );
    const RecentlyCustomers = customersList.map((c) => ({
        id: c.createdFrom === 'shop_imported' ? c.refIdImport : c.refIdUsers || c.customerId || c._id,
        email: c.email,
        name: `${c.firstName || ''} ${c.lastName || ''}`.trim(),
        phone: c.phoneNumber,
        primaryPhoneNumberType: c.primaryPhoneNumberType || 'mobile',
        company: c.company,
        isFleetCustomer: c.isFleetCustomer,
        createdFrom: c.createdFrom, // ← add this
    }));

    const displayCustomers =
        customers.length > 0
            ? customers.map((c) => ({
                  id: c?.createdFrom === 'shop_imported' ? c.refIdImport : c.refIdUsers || c.customerId || c._id, // ← same strategy
                  name: c.fullName || `${c.firstName || ''} ${c.lastName || ''}`.trim() || 'No Name',
                  phoneNumber: c.phoneNumber,
                  primaryPhoneNumberType: c.primaryPhoneNumberType || 'mobile',
                  company: c.company || '',
                  createdFrom: c.createdFrom,
                  isFleetCustomer: c.isFleetCustomer || c.shopCustomer?.isFleetCustomer || false,
                  email: c.email,
              }))
            : [];

    // Add a loader sentinel row at the end during pagination fetches
    const LOADER_OPTION = { id: '__loader__', name: '__loader__' };
    const optionsWithLoader = isFetchingNextPage ? [...displayCustomers, LOADER_OPTION] : displayCustomers;

    useEffect(() => {
        if (!newCustomer.phoneNumber && !newCustomer.firstName && !newCustomer.email) {
            // Parent reset the newCustomer state — sync the RHF form too
            reset({ firstName: '', phoneNumber: '', email: '' });
        }
    }, [newCustomer.phoneNumber, newCustomer.firstName, newCustomer.email]);

    // When dropdown closes, collapse the chips view
    useEffect(() => {
        // handled inline via setChipsExpanded(false) on close
    }, []);

    const scroll = (offset) => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({ left: offset, behavior: 'smooth' });
        }
    };
    const fetchCustomers = async (searchText = '', pageToFetch = 1, { append = false } = {}) => {
        try {
            // cancel only if request exists (avoid canceling pagination requests unless starting a new search)
            if (!append && cancelTokenSourceRef.current) cancelTokenSourceRef.current.cancel();

            const source = axios.CancelToken.source();
            cancelTokenSourceRef.current = source;

            if (append) setIsFetchingNextPage(true);
            else setLoading(true);

            const resp = await dispatch(
                CustomersListBasedOnType(searchText, ['shop_created', 'apex_auto_app', 'shop_imported', 'shop_guest'], pageToFetch, customerLimit, source.token)
            );

            if (resp?.data) {
                setCustomers((prev) => (append ? [...prev, ...resp.data] : resp.data));
                setPageMeta({
                    totalpages: resp?.totalPages ?? resp?.totalpages ?? 0,
                    currentPage: resp?.currentPage ?? pageToFetch,
                });
                setPage(pageToFetch);
            } else {
                if (!append) setCustomers([]);
            }
        } catch (err) {
            if (!axios.isCancel(err)) {
                console.error('Search error:', err);
            }
        } finally {
            setLoading(false);
            setIsFetchingNextPage(false);
        }
    };

    useEffect(() => {
        if (newCustomer.firstName) setValue('firstName', newCustomer.firstName);
        if (newCustomer.phoneNumber) setValue('phoneNumber', newCustomer.phoneNumber);
        if (newCustomer.email) setValue('email', newCustomer.email);
    }, []);

    // Seed customers list from prefetched page 1
    useEffect(() => {
        if (Array.isArray(prefetchedCustomersPage1) && prefetchedCustomersPage1.length > 0) {
            setCustomers(prefetchedCustomersPage1);
            setPage(1);
        }
    }, [prefetchedCustomersPage1]);

    useEffect(() => {
        const checkOverflow = () => {
            const el = scrollContainerRef.current;
            if (el) {
                setShowArrows(el.scrollWidth > el.clientWidth);
            }
        };

        checkOverflow();

        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, [RecentlyCustomers]);

    useEffect(() => {
        const delay = setTimeout(() => {
            if (search.trim().length >= 2) {
                fetchCustomers(search, 1, { append: false });
            } else {
                fetchCustomers('', 1, { append: false });
            }
        }, 400);

        return () => clearTimeout(delay);
    }, [search]);

    const handleScroll = (e) => {
        const listboxNode = e.currentTarget;
        const reachedBottom = listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 1;

        if (!reachedBottom) return;
        if (loading || isFetchingNextPage) return;

        const totalpages = pageMeta.totalpages || 0;
        if (!totalpages || totalpages <= page) return;

        const nextPage = page + 1;
        fetchCustomers(search.trim().length >= 2 ? search : '', nextPage, { append: true });
    };

    //  Auto-select shop's country as default once list is loadeda
    useEffect(() => {
        if (countryList?.length && !selectedCountry) {
            const defaultCountry = countryList.find((c) => c._id === shopCountryId) || countryList[0];
            setSelectedCountry(defaultCountry);
        }
    }, [countryList, selectedCountry]);

    const handleCountryChange = (e) => {
        const country = countryList?.find((c) => c._id === e.target.value);
        if (country) setSelectedCountry(country);
    };

    const checkPhoneMutation = useCheckPhoneNumber({
        onSuccess: (resp) => {
            const customer = resp?.status && resp?.data ? resp.data : null;
            if (!customer?._id) {
                setFoundCustomerOption(null);
                onFoundCustomerChange?.(null);
                return;
            }

            const createdFrom = customer?.createdFrom ? customer.createdFrom : customer?.shopImported ? 'shop_imported' : 'shop_created';
            setFoundCustomerOption({
                id: customer._id,
                name: `${customer.firstName || ''} ${customer.lastName || ''}`.trim() || 'Customer',
                phoneNumber: customer.phoneNumber,
                primaryPhoneNumberType: customer.primaryPhoneNumberType || 'mobile',
                company: customer.company || '',
                createdFrom,
                isFleetCustomer: customer?.isFleetCustomer || false,
                email: customer.email,
            });
            onFoundCustomerChange?.({
                id: customer._id,
                name: `${customer.firstName || ''} ${customer.lastName || ''}`.trim() || 'Customer',
                phoneNumber: customer.phoneNumber,
                primaryPhoneNumberType: customer.primaryPhoneNumberType || 'mobile',
                company: customer.company || '',
                createdFrom,
                isFleetCustomer: customer?.isFleetCustomer || false,
                email: customer.email,
            });
        },
        onError: () => {
            setFoundCustomerOption(null);
            onFoundCustomerChange(null);
        },
    });

    useEffect(() => {
        if (!addCustomerOpen) return;
        if (selectedArray.length > 0) return;

        const digits = removeDashFromPhoneNumber(newCustomer.phoneNumber || '');
        const countryId = selectedCountry?._id;
        const dial = selectedCountry?.dial_code;

        if (!countryId || !dial || digits.length !== 10) {
            setFoundCustomerOption(null);
            onFoundCustomerChange(null);
            lastPhoneCheckKeyRef.current = '';
            return;
        }

        const key = `${countryId}:${digits}`;
        if (lastPhoneCheckKeyRef.current === key) return;

        const t = setTimeout(() => {
            lastPhoneCheckKeyRef.current = key;
            checkPhoneMutation.mutate({
                phoneNumber: digits,
                countryCode: dial,
                phoneNumberCountry: countryId,
            });
        }, 400);

        return () => clearTimeout(t);
    }, [newCustomer.phoneNumber, selectedCountry, addCustomerOpen, selectedArray.length]);

    const handleAutocompleteChange = (event, newValue) => {
        const prevArray = Array.isArray(selectedCustomer) ? selectedCustomer : [];
        const nextArray = Array.isArray(newValue) ? newValue : [];

        const seen = new Set();
        const deduped = [...nextArray]
            .reverse()
            .filter((c) => {
                if (seen.has(c.id)) return false;
                seen.add(c.id);
                return true;
            })
            .reverse();

        setSelectedCustomer(deduped);
        if (deduped.length > prevArray.length) {
            setSearch('');
        }
    };
    const isSelected = (cust) => selectedArray.some((s) => s.id === cust.id);

    const handleCardClick = (cust) => {
        console.log('dsfsdfsdfsd', cust);
        if (isSelected(cust)) {
            setSelectedCustomer(selectedArray.filter((s) => s.id !== cust.id));
        } else {
            console.log('dsfsdfsdfsd', cust);
            setSelectedCustomer([...selectedArray, cust]);
            setSearch('');
            setAddCustomerOpen(false);
        }
    };
    return (
        <Box>
            {/*  Existing Customer Header  */}
            <Box display="flex" alignItems="center" gap={1} sx={{ mb: '8px' }}>
                <Group sx={{ color: '#006CDD' }} />
                <Typography sx={{ fontSize: '18px', fontWeight: 500, color: '#111827' }}>Existing Customer</Typography>
            </Box>

            {/* Multi-select Autocomplete */}
            <MultiSelectAutocomplete
                selectedArray={selectedArray}
                setSelectedCustomer={setSelectedCustomer}
                search={search}
                setSearch={setSearch}
                loading={loading}
                isFetchingNextPage={isFetchingNextPage}
                optionsWithLoader={optionsWithLoader}
                LOADER_OPTION={LOADER_OPTION}
                handleScroll={handleScroll}
                toast={toast}
                onDropdownClose={(hasSelection) => {
                    if (hasSelection) setAddCustomerOpen(false);
                }}
            />

            {!!selectedViaLookup && (
                <Box
                    sx={{
                        mt: '-8px',
                        mb: '16px',
                        px: '12px',
                        py: '10px',
                        borderRadius: '4px',
                        background: '#EDF7ED',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                            d="M10 18.3333C5.4 18.3333 1.66667 14.6 1.66667 10C1.66667 5.4 5.4 1.66667 10 1.66667C14.6 1.66667 18.3333 5.4 18.3333 10C18.3333 14.6 14.6 18.3333 10 18.3333ZM9.16667 13.3333L15.0583 7.44167L13.8833 6.26667L9.16667 10.9917L6.80833 8.63333L5.63333 9.80833L9.16667 13.3333Z"
                            fill="#2E7D32"
                        />
                    </svg>
                    <Typography
                        sx={{
                            color: '#1E4620',
                            fontFeatureSettings: "'liga' off, 'clig' off",
                            fontFamily: 'Roboto',
                            fontSize: '14px',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            lineHeight: '123.5%',
                            letterSpacing: '0.25px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                        }}
                    >
                        Using Existing Customer Record
                        <Box
                            component="span"
                            onClick={() => {
                                const prevArray = Array.isArray(selectedCustomer) ? selectedCustomer : [];
                                const nextArray = prevArray.filter((c) => c?.id !== selectedViaLookup?.id);
                                setSelectedCustomer(nextArray);

                                const hasAnyLeft = nextArray.length > 0;
                                if (!hasAnyLeft && cachedNewCustomerForUndo?.newCustomer) {
                                    setNewCustomer({ ...cachedNewCustomerForUndo.newCustomer });
                                    reset({
                                        firstName: cachedNewCustomerForUndo.newCustomer.firstName || '',
                                        phoneNumber: cachedNewCustomerForUndo.newCustomer.phoneNumber || '',
                                        email: cachedNewCustomerForUndo.newCustomer.email || '',
                                    });
                                    if (cachedNewCustomerForUndo?.selectedCountry) {
                                        setSelectedCountry(cachedNewCustomerForUndo.selectedCountry);
                                    }
                                    setAddCustomerOpen(true);
                                }

                                setSelectedViaLookup(null);
                                setCachedNewCustomerForUndo(null);
                            }}
                            sx={{
                                cursor: 'pointer',
                                color: '#006CDD',
                                fontFeatureSettings: "'liga' off, 'clig' off",
                                fontFamily: 'Roboto',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: 600,
                                lineHeight: '123.5%',
                                letterSpacing: '0.25px',
                                textDecorationLine: 'underline',
                                textDecorationStyle: 'solid',
                                textDecorationSkipInk: 'none',
                                textDecorationThickness: 'auto',
                                textUnderlineOffset: 'auto',
                                textUnderlinePosition: 'from-font',
                            }}
                        >
                            Undo
                        </Box>
                    </Typography>
                </Box>
            )}

            {/*  Recent Customer Cards (scrollable)  */}
            <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', mb: '24px' }}>
                {showArrows && (
                    <IconButton
                        onClick={() => scroll(-200)}
                        sx={{
                            ...styles.arrowButtonStyles,
                            left: '-16px',
                            borderRadius: '30px',
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: 14 }} />
                    </IconButton>
                )}

                <Box
                    ref={scrollContainerRef}
                    sx={{
                        display: 'flex',
                        gap: 1.5,
                        overflowX: 'auto',
                        px: 0.5,
                        width: '100%',

                        justifyContent: RecentlyCustomers.length <= 3 ? 'space-between' : 'flex-start',

                        scrollBehavior: 'smooth',
                        '&::-webkit-scrollbar': { display: 'none' },
                        scrollbarWidth: 'none',
                    }}
                >
                    {RecentlyCustomers.map((cust, i) => {
                        const selected = isSelected(cust);
                        return (
                            <div
                                key={i}
                                onClick={() => handleCardClick(cust)}
                                style={{
                                    position: 'relative',
                                    flex: RecentlyCustomers.length <= 3 ? 1 : '0 0 209px',
                                    minWidth: RecentlyCustomers.length <= 3 ? 0 : '209px',
                                    cursor: 'pointer',
                                    maxWidth: RecentlyCustomers.length <= 3 ? '100%' : '209px',

                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '5px',
                                    padding: '10px 12px',
                                    borderRadius: '5px',
                                    border: selected ? '1px solid #1976D2' : '1px solid #E5E7EB',
                                    background: '#FFF',
                                }}
                            >
                                {/* Top-right icons */}
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 12,
                                        right: 12,
                                        display: 'flex',
                                        gap: 0.5,
                                    }}
                                >
                                    {cust.isFleetCustomer && (
                                        <Box
                                            sx={{
                                                width: 20,
                                                height: 20,
                                                bgcolor: '#FFF3E0',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <FleetIconSvg height="12px" width="12px" />
                                        </Box>
                                    )}
                                </Box>

                                <Typography
                                    sx={{
                                        color: '#212121',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        lineHeight: 'normal',
                                    }}
                                >
                                    {cust.name}
                                </Typography>
                                {cust.phone && (
                                    <Box display="flex" alignItems="center" gap={0.5} mb={'3px'}>
                                        {SmallPhoneTypeIcon(cust?.primaryPhoneNumberType || 'mobile', '16px', '16px')}
                                        <Typography
                                            sx={{
                                                fontSize: '14px',
                                                fontWeight: 400,
                                                color: 'rgba(0, 0, 0, 0.80)',
                                                '& svg': {
                                                    width: '16px',
                                                    height: '16px',
                                                },
                                            }}
                                        >
                                            {cust.phone ? formatPhoneNumber(cust.phone) : ''}
                                        </Typography>
                                    </Box>
                                )}
                                {cust.email && (
                                    <Box display="flex" alignItems="center" gap={0.5}>
                                        <MailOutline sx={{ fontSize: 16, color: '#1976D2' }} />

                                        <Typography
                                            sx={{
                                                fontSize: '14px',
                                                fontWeight: 400,
                                                color: 'rgba(0, 0, 0, 0.80)',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {cust.email}
                                        </Typography>
                                    </Box>
                                )}
                            </div>
                        );
                    })}
                </Box>
                {showArrows && (
                    <IconButton
                        onClick={() => scroll(200)}
                        sx={{
                            ...styles.arrowButtonStyles,
                            right: '-18px',
                        }}
                    >
                        <ArrowForwardIcon sx={{ fontSize: 14 }} />
                    </IconButton>
                )}
            </Box>

            {/*  OR divider  */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Divider sx={{ flex: 1 }} />
                <Typography sx={{ px: 2, fontSize: '14px', color: '#6B7280', fontWeight: 500 }}>OR</Typography>
                <Divider sx={{ flex: 1 }} />
            </Box>

            {/*  Add New Customer  */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: addCustomerOpen ? '24px' : 0,
                    p: '0px!important',
                    borderRadius: '8px',
                    background: '#FFF',
                    // boxShadow: '0 0 4px rgba(0,0,0,0.10)',
                    mb: 3,
                    transition: 'all 0.2s ease',
                }}
            >
                <Box
                    onClick={() => {
                        if (selectedArray.length > 0) {
                            toast.error(`Remove selected ${selectedArray.length > 1 ? 'customers' : 'customer'} to add a new one`);
                            return;
                        }
                        setAddCustomerOpen((prev) => !prev);
                    }}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                        cursor: 'pointer',
                        userSelect: 'none',
                    }}
                >
                    {/* LEFT SIDE */}

                    <PersonAddAlt1Icon sx={{ width: '24px', height: '24px', color: '#006CDD' }} />
                    <Typography
                        sx={{
                            fontSize: '18px',
                            fontWeight: 500,
                            color: '#111827',
                            flexGrow: 1,
                        }}
                    >
                        Add New Customer
                    </Typography>

                    {/* RIGHT ICON */}
                    <IconButton
                        size="small"
                        disableRipple
                        sx={{
                            p: 0,
                        }}
                    >
                        {addCustomerOpen ? (
                            <KeyboardArrowUpIcon
                                sx={{
                                    borderRadius: '50%',
                                    background: '#334FA9',
                                    color: '#FFF',
                                    width: '30px',
                                    height: '30px',
                                }}
                            />
                        ) : (
                            <KeyboardArrowDownIcon
                                sx={{
                                    borderRadius: '50%',
                                    background: '#334FA9',
                                    color: '#FFF',
                                    width: '30px',
                                    height: '30px',
                                }}
                            />
                        )}
                    </IconButton>
                </Box>

                <Collapse in={addCustomerOpen}>
                    <Box
                        sx={{
                            p: '0 16px',
                        }}
                    >
                        <Grid container spacing={2}>
                            {/* Phone (Row 1) */}
                            <Grid item xs={12}>
                                <PhoneField
                                    label="Mobile Number"
                                    isRequired={true}
                                    phoneNumberFieldName="phoneNumber"
                                    control={control}
                                    errors={errors}
                                    setValue={setValue}
                                    setError={setError}
                                    clearErrors={clearErrors}
                                    selectedCountry={selectedCountry}
                                    handleCountryChange={handleCountryChange}
                                    countryList={countryList}
                                    phoneInputRef={phoneInputRef}
                                    setNewCustomer={setNewCustomer}
                                    isCheckingPhone={checkPhoneMutation.isPending}
                                    phoneTypes={phoneTypes}
                                />

                                {checkPhoneMutation.isPending && (
                                    <Box sx={{ mt: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <SearchIcon sx={{ color: 'rgba(0, 0, 0, 0.80)', fontSize: 20 }} />
                                        <Typography
                                            sx={{
                                                fontSize: '14px',
                                                fontWeight: 500,
                                                color: 'rgba(0, 0, 0, 0.80)',
                                                lineHeight: '123.5%',
                                                letterSpacing: '0.25px',
                                            }}
                                        >
                                            Checking for existing customer...
                                        </Typography>
                                    </Box>
                                )}

                                {!!foundCustomerOption && !checkPhoneMutation.isPending && (
                                    <Box
                                        sx={{
                                            mt: '12px',
                                            px: '12px',
                                            py: '10px',
                                            borderRadius: '4px',
                                            background: '#EDF7ED',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path
                                                d="M10 18.3333C5.4 18.3333 1.66667 14.6 1.66667 10C1.66667 5.4 5.4 1.66667 10 1.66667C14.6 1.66667 18.3333 5.4 18.3333 10C18.3333 14.6 14.6 18.3333 10 18.3333ZM9.16667 13.3333L15.0583 7.44167L13.8833 6.26667L9.16667 10.9917L6.80833 8.63333L5.63333 9.80833L9.16667 13.3333Z"
                                                fill="#2E7D32"
                                            />
                                        </svg>
                                        <Typography
                                            sx={{
                                                color: '#1E4620',
                                                fontFeatureSettings: "'liga' off, 'clig' off",
                                                fontFamily: 'Roboto',
                                                fontSize: '14px',
                                                fontStyle: 'normal',
                                                fontWeight: 400,
                                                lineHeight: '123.5%',
                                                letterSpacing: '0.25px',
                                            }}
                                        >
                                            Customer found:{' '}
                                            <Box
                                                component="span"
                                                onClick={() => {
                                                    // cache for undo
                                                    setCachedNewCustomerForUndo({
                                                        newCustomer: { ...newCustomer },
                                                        selectedCountry,
                                                    });
                                                    setSelectedViaLookup(foundCustomerOption);

                                                    // select into existing customer multiselect (dedupe by id)
                                                    const prevArray = Array.isArray(selectedCustomer) ? selectedCustomer : [];
                                                    const exists = prevArray.some((c) => c?.id === foundCustomerOption.id);
                                                    const next = exists ? prevArray : [...prevArray, foundCustomerOption];
                                                    setSelectedCustomer(next);

                                                    // clear new customer fields and collapse
                                                    setNewCustomer({ firstName: '', phoneNumber: '', email: '' });
                                                    reset({ firstName: '', phoneNumber: '', email: '' });
                                                    setAddCustomerOpen(false);

                                                    // hide found bar
                                                    setFoundCustomerOption(null);
                                                    onFoundCustomerChange(null);
                                                    lastPhoneCheckKeyRef.current = '';
                                                }}
                                                sx={{
                                                    cursor: 'pointer',
                                                    color: '#006CDD',
                                                    fontFeatureSettings: "'liga' off, 'clig' off",
                                                    fontFamily: 'Roboto',
                                                    fontSize: '14px',
                                                    fontStyle: 'normal',
                                                    fontWeight: 600,
                                                    lineHeight: '123.5%',
                                                    letterSpacing: '0.25px',
                                                    textDecorationLine: 'underline',
                                                    textDecorationStyle: 'solid',
                                                    textDecorationSkipInk: 'none',
                                                    textDecorationThickness: 'auto',
                                                    textUnderlineOffset: 'auto',
                                                    textUnderlinePosition: 'from-font',
                                                }}
                                            >
                                                Use {foundCustomerOption.name} Details
                                            </Box>
                                        </Typography>
                                    </Box>
                                )}
                            </Grid>

                            {/* Row 2: First Name + Email */}
                            <Grid item xs={12} sm={6}>
                                <Typography sx={labelStyle}>
                                    First Name <span style={{ color: '#EF4444' }}>*</span>
                                </Typography>
                                <TextField
                                    fullWidth
                                    disabled={!!foundCustomerOption}
                                    sx={foundCustomerOption ? MuiDisabledTextField : MuiTextFieldWithFocus}
                                    size="small"
                                    value={newCustomer.firstName}
                                    onChange={(e) =>
                                        setNewCustomer((prev) => ({
                                            ...prev,
                                            firstName: e.target.value,
                                        }))
                                    }
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Typography sx={labelStyle}>Email Address</Typography>
                                <TextField
                                    fullWidth
                                    disabled={!!foundCustomerOption}
                                    sx={foundCustomerOption ? MuiDisabledTextField : MuiTextFieldWithFocus}
                                    size="small"
                                    value={newCustomer.email}
                                    onChange={(e) =>
                                        setNewCustomer((prev) => ({
                                            ...prev,
                                            email: e.target.value,
                                        }))
                                    }
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Collapse>
            </Box>
        </Box>
    );
};

export default CustomerSelector;
